import $ from 'jquery';

var $tiles = $('.tiles__navigation-item');
setTileHeight();

$(window).on('resize', function () {
    setTileHeight();
})


$tiles.on('click', function () {
    var $wrap = $(this).closest('.tiles');
    $(this).addClass('tiles__navigation-item--active');
    $(this).siblings('.tiles__navigation-item').removeClass('tiles__navigation-item--active')
    $wrap.find('.tiles__tile').removeClass('tiles__tile--active');
    $wrap.find('.tiles__tile[data-id="' + $(this).data('target') + '"]').addClass('tiles__tile--active');
})

function setTileHeight() {
    var biggestHeight = 0;
    var $wrap = $('.tiles');
    $wrap.each(function () {
        var $tiles = $(this).find('.tiles__tile');
        $tiles.removeAttr('style');
        if($(window).width() < 768) {
            var activeId = $wrap.find('.tiles__tile--active').data('id');
            $tiles.addClass('tiles__tile--active');
            $tiles.each(function () {
                var tileHeight = $(this).outerHeight();
                if (tileHeight > biggestHeight) {
                    biggestHeight = tileHeight;
                }
            })

            $wrap.find('.tiles__tile').height(biggestHeight);
            $wrap.find('.tiles__tile').removeClass('tiles__tile--active');
            if(activeId === undefined) {
                $wrap.find('.tiles__tile[data-id="1"]').addClass('tiles__tile--active');
            } else {
                $wrap.find('.tiles__tile[data-id="'+ activeId +'"]').addClass('tiles__tile--active');

            }
        }
    })
}